import gtmHelpers from '../gtmHelpers'
import {gtmEvent, segment} from './helpers'

import {TRANSACTION_TYPE_BUY, TRANSACTION_TYPE_RENT, TRANSACTION_TYPE_RENT_ADD} from '../const'

export const addProduct = ({
  addedProduct: {buyPrice, id, name, rentPrice},
  categorySlug,
  origin,
  productName,
  setType,
  transactionType,
}) => {
  let price
  if (transactionType === TRANSACTION_TYPE_RENT || transactionType === TRANSACTION_TYPE_RENT_ADD) {
    price = rentPrice
  } else if (transactionType === TRANSACTION_TYPE_BUY) {
    price = buyPrice
  } else {
    price = 'Free Home Try-On'
  }

  gtmEvent(
    'addToCart',
    gtmHelpers.genericEcommerce(setType === 'group' ? 'addCurated' : 'addToCart', {
      id,
      name,
      price,
      categorySlug,
    }),
  )

  segment('Added Product Client', {
    productCategory: categorySlug,
    name: productName,
    transactionType,
    origin,
  })
}

// From Recommendation Modal
export const viewedRecommendationModal = () => segment('Viewed Cross Sell Module')

/**
 * Fires once the HTO Gating Modal is dispatched
 * @param {Number} daysToEvent Days between today and event date
 */
export const viewedAtlBlockModal = (daysToEvent, error) =>
  segment('Viewed Add To Look Block Modal', {
    daysToEvent,
    error,
  })
